import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { IDatePickerConfig } from 'ng2-date-picker';
import { Subject } from 'rxjs/internal/Subject';
import * as filesaver from 'file-saver';
import { takeUntil } from 'rxjs/operators';
import { SubscriptionPlanRepo } from 'src/app/repositories/subscriptionPlan-repo';
import { checkIfEndDateAfterStartDate, dateFormat, numberFormat } from 'src/app/shared/validators/custom.validators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { ReportType } from '../../models/report-type';

@Component({
    selector: 'app-modal-new-export',
    templateUrl: './modal-new-export.component.html',
    styleUrls: ['./modal-new-export.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalNewExportComponent implements OnInit {

  isDownloadLoading = false;
  reportTypes!: ReportType[];
  destroyed$ = new Subject<void>();
  language: 'fr' | 'en' = 'fr';
  datePickerConfig: IDatePickerConfig = {
    disableKeypress: false,
    format: 'DD/MM/YYYY',
    monthFormat: 'MMMM, YYYY',
    firstDayOfWeek: 'mo',
    showTwentyFourHours: true,
    showSeconds: false,
    showGoToCurrent: true,
    showNearMonthDays: false,
    hideOnOutsideClick: true,
    enableMonthSelector: true,
    allowMultiSelect: false
  };

  now = moment.default();
  validityStartDisplayDate =  moment.default().subtract(10, 'days');
  validityEndDefault = this.now;
  validityEndDisplayDate = this.validityEndDefault;

  // FORM
  get f() {
    return this.exportForm.controls;
  }
  exportForm = this.fb.group({
    validityStart: [null, dateFormat(this.datePickerConfig.format)],
    validityEnd: [this.validityEndDefault, [Validators.required, dateFormat(this.datePickerConfig.format)]],
    reportType: ['', Validators.required],
  });

  endDatePickerConfig = this.datePickerConfig;
  startDatePickerConfig = this.datePickerConfig;

  constructor(private fb: UntypedFormBuilder,
    private subscriptionPlanRepo: SubscriptionPlanRepo,
    @Inject(MAT_DIALOG_DATA) public uid: string,
    private dialogRef: MatDialogRef<ModalNewExportComponent> 
    ) { }

  ngOnInit(): void {
    this.reportTypes = Object.values(ReportType);
    this.patchValues();
    this.exportForm.get('validityStart').patchValue(this.validityStartDisplayDate.startOf('day'));
    this.exportForm.get('validityEnd').patchValue(moment.default().startOf('day'));
    this.exportForm.addValidators(checkIfEndDateAfterStartDate('validityStart', 'validityEnd'));
  }

  onSubmit() {
    this.exportForm.markAllAsTouched();
    const formValues = this.exportForm.getRawValue();
    const start =  formValues.validityStart ? moment.default(formValues.validityStart) : null ;
    const end: moment.Moment = moment.default(formValues.validityEnd);

    if (this.exportForm.valid) {
        this.isDownloadLoading = true;
        this.subscriptionPlanRepo
          .downloadReportNow(this.uid, start.toISOString(), end.toISOString(), this.exportForm.controls.reportType.value )
          .pipe(takeUntil(this.destroyed$))
          .subscribe({
            next: (response) => {
              const filename = response.headers
                .get('content-disposition')
                .split('=');
              const blob = new Blob([response.body], {
                type: response.headers.get('content-type'),
              });
              filesaver.saveAs(blob, filename[1].slice(1, -1));
              this.isDownloadLoading = false;
              this.dialogRef.close();
            },
            error: (error) => {
              this.isDownloadLoading = false;
            },
          });


    }
  }

  patchValues() {
    this.exportForm.patchValue({
      reportType: null
    });
  }

}
